module.exports = {
  sm: '20px',
  md: '32px',
  lg: '60px',
  xl: '100px',
};
